import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

import { LivePreview } from "./LivePreview";

interface CountdownScreenProps {
  count: number;
}

export const CountdownScreen = ({ count }: CountdownScreenProps) => (
  <div className="relative flex flex-col gap-4">
    <LivePreview>
      <div className="absolute inset-0 flex items-center justify-center bg-black/50 text-white">
        <Typography variant="heading-xl" color="current">
          {t("tiptap.video_clip.recording_begins_in", { count })}
        </Typography>
      </div>
    </LivePreview>
  </div>
);
